module.exports = __webpack_public_path__ + "img/first-order-alt.cea2e65d.svg";